"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-3a2b8aab"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "paginator-container" };
const _hoisted_2 = { class: "page-selector page-selector-xs show-xs" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-chevron-left zmdi-hc-lg" }, null, -1 /* HOISTED */));
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = { class: "prev-btn page-btn" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "/", -1 /* HOISTED */));
const _hoisted_7 = { class: "prev-btn page-btn" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-chevron-right zmdi-hc-lg" }, null, -1 /* HOISTED */));
const _hoisted_9 = [
    _hoisted_8
];
const _hoisted_10 = {
    key: 0,
    class: "page-selector hide-xs"
};
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-chevron-left zmdi-hc-lg" }, null, -1 /* HOISTED */));
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-chevron-left zmdi-hc-lg" }, null, -1 /* HOISTED */));
const _hoisted_13 = [
    _hoisted_11,
    _hoisted_12
];
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-chevron-left zmdi-hc-lg" }, null, -1 /* HOISTED */));
const _hoisted_15 = [
    _hoisted_14
];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-chevron-right zmdi-hc-lg" }, null, -1 /* HOISTED */));
const _hoisted_18 = [
    _hoisted_17
];
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-chevron-right zmdi-hc-lg" }, null, -1 /* HOISTED */));
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-chevron-right zmdi-hc-lg" }, null, -1 /* HOISTED */));
const _hoisted_21 = [
    _hoisted_19,
    _hoisted_20
];
const _hoisted_22 = {
    key: 1,
    class: "items-per-page-selector"
};
const _hoisted_23 = ["value", "selected"];
const _hoisted_24 = { key: 0 };
const _hoisted_25 = { key: 1 };
const vue_3 = require("vue");
// Usage: Import this component and pass on the following props:
var PageSize;
(function (PageSize) {
    PageSize[PageSize["ShowAll"] = 0] = "ShowAll";
})(PageSize || (PageSize = {}));
exports.default = (0, vue_1.defineComponent)({
    __name: 'Paginator',
    props: {
        totalData: {
            type: Number,
            default: 1,
        },
        currentPage: {
            type: Number,
            default: 1,
        },
        itemsPerPage: {
            type: Number,
            default: 25,
        },
        itemsPerPageOptions: {
            type: Array,
            default: [25, 50, 100]
        },
        // Visible number of pages;
        visiblePages: {
            type: Number,
            default: 5,
        },
        showPerPageOption: {
            type: Boolean,
            default: true,
        },
        showPageNum: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['update:currentPage'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const itemsPerPageLocal = (0, vue_3.ref)(25); // default
        const totalPages = (0, vue_3.computed)(() => {
            // Total pages, min value must be 1
            if (props.itemsPerPage == PageSize.ShowAll) {
                return 1;
            }
            return Math.max(Math.ceil(props.totalData / props.itemsPerPage), 1);
        });
        const isCurrentInLastPage = (0, vue_3.computed)(() => {
            return props.currentPage == totalPages.value;
        });
        const isCurrentInFirstPage = (0, vue_3.computed)(() => {
            return props.currentPage == 1;
        });
        const disableNextBtn = (0, vue_3.computed)(() => {
            return isCurrentInLastPage.value ? 'disabled-btn' : '';
        });
        const disablePrevBtn = (0, vue_3.computed)(() => {
            return isCurrentInFirstPage.value ? 'disabled-btn' : '';
        });
        const isPerPageOptionVisible = (0, vue_3.computed)(() => {
            return props.showPerPageOption && props.itemsPerPageOptions.includes(props.itemsPerPage);
        });
        const pages = (0, vue_3.computed)(() => {
            const half = Math.floor(props.visiblePages / 2);
            const start = Math.max(1, Math.min(props.currentPage - half, totalPages.value - props.visiblePages + 1));
            const end = Math.min(totalPages.value, Math.max(props.currentPage + half, props.visiblePages));
            const outPages = [];
            for (let i = start; i <= end; i++) {
                outPages.push(i);
            }
            return outPages;
        });
        const emit = __emit;
        function nextPage() {
            if (props.currentPage < totalPages.value) {
                const emitData = {
                    currentPage: props.currentPage + 1,
                    itemsPerPage: props.itemsPerPage,
                };
                emit('update:currentPage', emitData);
            }
        }
        ;
        function previousPage() {
            if (props.currentPage > 1) {
                const emitData = {
                    currentPage: props.currentPage - 1,
                    itemsPerPage: props.itemsPerPage,
                };
                emit('update:currentPage', emitData);
            }
        }
        ;
        function goToFirstPage() {
            if (props.currentPage != 1) {
                goToPage(1);
            }
        }
        ;
        function goToLastPage() {
            if (props.currentPage != totalPages.value) {
                goToPage(totalPages.value);
            }
        }
        ;
        function goToPage(page) {
            const emitData = {
                currentPage: page,
                itemsPerPage: props.itemsPerPage,
            };
            emit('update:currentPage', emitData);
        }
        ;
        function handleItemsNumChange() {
            const emitData = {
                currentPage: props.currentPage,
                itemsPerPage: itemsPerPageLocal.value,
            };
            emit('update:currentPage', emitData);
        }
        (0, vue_3.onMounted)(() => {
            itemsPerPageLocal.value = props.itemsPerPage;
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createCommentVNode)(" Max width: 480px  "),
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createCommentVNode)(" Prev button "),
                    (0, vue_2.createElementVNode)("button", {
                        class: (0, vue_2.normalizeClass)(["prev-btn page-btn", disablePrevBtn.value]),
                        onClick: previousPage
                    }, _hoisted_4, 2 /* CLASS */),
                    (0, vue_2.createElementVNode)("span", _hoisted_5, (0, vue_2.toDisplayString)(__props.currentPage), 1 /* TEXT */),
                    _hoisted_6,
                    (0, vue_2.createElementVNode)("span", _hoisted_7, (0, vue_2.toDisplayString)(totalPages.value), 1 /* TEXT */),
                    (0, vue_2.createCommentVNode)(" Next Button "),
                    (0, vue_2.createElementVNode)("button", {
                        class: (0, vue_2.normalizeClass)(["next-btn page-btn", disableNextBtn.value]),
                        onClick: nextPage
                    }, _hoisted_9, 2 /* CLASS */)
                ]),
                (0, vue_2.createCommentVNode)(" Bigger Screen "),
                (itemsPerPageLocal.value !== 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, [
                        (0, vue_2.createElementVNode)("div", null, [
                            (0, vue_2.createCommentVNode)(" Start button "),
                            (0, vue_2.createElementVNode)("button", {
                                class: (0, vue_2.normalizeClass)(["prev-btn page-btn", disablePrevBtn.value]),
                                onClick: _cache[0] || (_cache[0] = ($event) => (goToFirstPage()))
                            }, _hoisted_13, 2 /* CLASS */),
                            (0, vue_2.createCommentVNode)(" Prev button "),
                            (0, vue_2.createElementVNode)("button", {
                                class: (0, vue_2.normalizeClass)(["prev-btn page-btn", disablePrevBtn.value]),
                                onClick: previousPage
                            }, _hoisted_15, 2 /* CLASS */)
                        ]),
                        (0, vue_2.createCommentVNode)(" Pages "),
                        (__props.showPageNum)
                            ? ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, (0, vue_2.renderList)(pages.value, (page, key) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                    class: (0, vue_2.normalizeClass)(["page-btn", { active: __props.currentPage == page }]),
                                    key: key,
                                    onClick: ($event) => (goToPage(page))
                                }, (0, vue_2.toDisplayString)(page), 11 /* TEXT, CLASS, PROPS */, _hoisted_16));
                            }), 128 /* KEYED_FRAGMENT */))
                            : (0, vue_2.createCommentVNode)("v-if", true),
                        (0, vue_2.createElementVNode)("div", null, [
                            (0, vue_2.createCommentVNode)(" Next Button "),
                            (0, vue_2.createElementVNode)("button", {
                                class: (0, vue_2.normalizeClass)(["next-btn page-btn", disableNextBtn.value]),
                                onClick: nextPage
                            }, _hoisted_18, 2 /* CLASS */),
                            (0, vue_2.createCommentVNode)(" End Button "),
                            (0, vue_2.createElementVNode)("button", {
                                class: (0, vue_2.normalizeClass)(["next-btn page-btn", disableNextBtn.value]),
                                onClick: _cache[1] || (_cache[1] = ($event) => (goToLastPage()))
                            }, _hoisted_21, 2 /* CLASS */)
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (isPerPageOptionVisible.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_22, [
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                            name: "items-per-page",
                            class: "items-selector",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((itemsPerPageLocal).value = $event)),
                            onChange: handleItemsNumChange
                        }, [
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.itemsPerPageOptions, (item) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                    value: item,
                                    selected: item == __props.itemsPerPage
                                }, [
                                    (item === 0)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_24, " 全て表示 "))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_25, (0, vue_2.toDisplayString)(item) + " 件 ", 1 /* TEXT */))
                                ], 8 /* PROPS */, _hoisted_23));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                            [vue_2.vModelSelect, itemsPerPageLocal.value]
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("v-if", true)
            ]));
        };
    }
});
